var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:(_vm.selected ? 'active' : '') + ' nav-item'},[_c('a',{staticClass:"nav-link",attrs:{"id":_vm.id +'-tab',"href":'#' + _vm.id,"data-toggle":"tab","role":"tab","aria-controls":_vm.id,"aria-selected":_vm.selected}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }